export class Task {
  constructor(
    public id: number,
    public title: string,
    public desc: string,
    public score: number){

  }
}
